import { ExamBuilderPage } from "./ExamBuilderPage";
export default ExamBuilderPage;
